import React from "react";
import { Spin } from "antd";
import NoDataAvailable from "./NoDataAvailable";

const ParameterOverview = ({ labAnalyticsDetails, isLoading }) => {
  const { parametersOverview } = labAnalyticsDetails || {};
  return (
    <div
      style={{
        padding: "20px 30px",
        border: "1px solid #E0E0E0",
        borderRadius: 8,
        backgroundColor: "#fff",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div style={{ flex: 1 }}>
        <p
          style={{
            fontWeight: "bold",
            fontSize: 16,
            paddingBottom: "5px",
            borderBottom: "1px solid #D9D9D9",
            marginBottom: "20px",
          }}
        >
          Parameter Overview
        </p>

        {isLoading ? (
          <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "200px",
            flexDirection: "column"
          }}>
            <Spin/>
            <p style={{
              marginTop: "16px",
              fontSize: "14px",
              color: "#8C8C8C"
            }}>Loading parameter overview...</p>
          </div>
        ) : !parametersOverview ? (
          <NoDataAvailable
            title="No Parameter Overview Available"
            description="Parameter statistics will appear here once data is available"
            height="200px"
          />
        ) : (
          <>
            {/* Total and Matched Section */}
            <div style={{ marginBottom: "30px" }}>
              {/* Total Row */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "10px",
                }}
              >
                <span
                  style={{
                    fontSize: "16px",
                    color: "#8C8C8C",
                    fontWeight: "normal",
                  }}
                >
                  Total
                </span>
                <span
                  style={{
                    fontSize: "24px",
                    fontWeight: "bold",
                    color: "#262626",
                  }}
                >
                  {parametersOverview?.totalParameters || 0}
                </span>
              </div>

              {/* Matched Row */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    fontSize: "14px",
                    color: "#8C8C8C",
                    fontWeight: "normal",
                  }}
                >
                  Matched
                </span>
                <span
                  style={{
                    fontSize: "20px",
                    fontWeight: "bold",
                    color: "#48a819ff",
                  }}
                >
                  {parametersOverview?.matchedParameters || 0}
                </span>
              </div>
            </div>

            {/* Bottom Statistics Section */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                gap: "30px",
                textAlign: "center",
              }}
            >
              {/* Missing */}
              <div>
                <p
                  style={{
                    fontSize: "14px",
                    color: "#8C8C8C",
                    margin: "0 0 8px 0",
                    fontWeight: "normal",
                  }}
                >
                  Missing
                </p>
                <p
                  style={{
                    fontSize: "24px",
                    fontWeight: "bold",
                    color: "#d10d10ff",
                    margin: "0",
                    lineHeight: "1",
                  }}
                >
                  {parametersOverview?.missingParameters || 0}
                </p>
              </div>

              {/* Manually Matched */}
              <div>
                <p
                  style={{
                    fontSize: "14px",
                    color: "#8C8C8C",
                    margin: "0 0 8px 0",
                    fontWeight: "normal",
                  }}
                >
                  Manually Matched
                </p>
                <p
                  style={{
                    fontSize: "24px",
                    fontWeight: "bold",
                    color: "#51be1aff",
                    margin: "0",
                    lineHeight: "1",
                  }}
                >
                  {parametersOverview?.manuallyMatchedParameters || 0}
                </p>
              </div>

              {/* Not Tested */}
              <div>
                <p
                  style={{
                    fontSize: "14px",
                    color: "#8C8C8C",
                    margin: "0 0 8px 0",
                    fontWeight: "normal",
                  }}
                >
                  Not Tested
                </p>
                <p
                  style={{
                    fontSize: "24px",
                    fontWeight: "bold",
                    color: "#cd781cff",
                    margin: "0",
                    lineHeight: "1",
                  }}
                >
                  {parametersOverview?.notTestedParameters || 0}
                </p>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ParameterOverview;
